import { Component, Input } from '@angular/core';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

export type HeaderPublicVariant = 'legacy' | 'v2';

@Component({
  selector: 'app-header-public',
  templateUrl: './header-public.component.html',
  styleUrls: ['./header-public.component.scss'],
  standalone: false,
})
export class HeaderPublicComponent {
  /** Si es false, no se muestran los botones "Iniciar sesión" y "Regístrate" (solo legacy). Por defecto true. */
  @Input() showAuthButtons = true;

  /** En variante v2: muestra el botón "Regístrate". Por defecto true. */
  @Input() showRegisterButton = true;

  /**
   * En variante v2: muestra logo Bancóldex a la derecha (p. ej. landing bienvenida Figma)
   * cuando no hay botones de auth.
   */
  @Input() showPartnerLogo = false;

  /** `v2` alinea con la línea gráfica HU 8300 (home). Por defecto `legacy`. */
  @Input() variant: HeaderPublicVariant = 'legacy';

  /** Ruta del botón "Iniciar sesión" (p. ej. `/intermediario/login` en flujos IF). */
  @Input() loginRouterLink: string = '/login';

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  trackIniciarSesion(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: 'Iniciar sesión',
      ctaSection: 'header',
      ctaComponent: 'header-public',
      ctaElementId: 'btn-header-iniciar-sesion',
      hu: '8335',
    });
  }
}
